import type { ComponentType } from "react";
import Dashboard from "../pages/dashboard/index.tsx";
import Management from "../pages/management/index.tsx";
import ManagementCreateEdit from "../pages/management/createEdit.tsx";
import Department from "../pages/department/index.tsx";
import DepartmentCreateEdit from "../pages/department/createEdit.tsx";
import FeeStructure from "../pages/feeStructure/index.tsx";
import FeeStructureCreateEdit from "../pages/feeStructure/createEdit.tsx";
import Results from "../pages/results/index.tsx";
import ResultCreateEdit from "../pages/results/createEdit.tsx";
import Gallery from "../pages/gallery/index.tsx";
import GalleryCreateEdit from "../pages/gallery/createEdit.tsx";
import MandatoryDisclosure from "../pages/mandatoryDisclosure/index.tsx";
import MandatoryDisclosureCreateEdit from "../pages/mandatoryDisclosure/createEdit.tsx";
import StaffDetails from "../pages/staffDetails/index.tsx";
import StaffDetailCreateEdit from "../pages/staffDetails/createEdit.tsx";
import ContactDetails from "../pages/contactDetails/index.tsx";
import ContactDetailCreateEdit from "../pages/contactDetails/createEdit.tsx";
import Facilities from "../pages/facilities/index.tsx";
import FacilityCreateEdit from "../pages/facilities/createEdit.tsx";
import Alumni from "../pages/alumni/index.tsx";
import AlumniCreateEdit from "../pages/alumni/createEdit.tsx";
import ContactConfiguration from "../pages/contactConfiguration/index.tsx";
import ContactConfigurationCreateEdit from "../pages/contactConfiguration/createEdit.tsx";
import CurricularActivities from "../pages/curricularActivities/index.tsx";
import CurricularActivityCreateEdit from "../pages/curricularActivities/createEdit.tsx";
import Events from "../pages/events/index.tsx";
import EventCreateEdit from "../pages/events/createEdit.tsx";
import Achievements from "../pages/achievements/index.tsx";
import AchievementCreateEdit from "../pages/achievements/createEdit.tsx";
import News from "../pages/news/index.tsx";
import NewsCreateEdit from "../pages/news/createEdit.tsx";
import Honours from "../pages/honours/index.tsx";
import HonourCreateEdit from "../pages/honours/createEdit.tsx";
import SchoolBuses from "../pages/schoolBuses/index.tsx";
import SchoolBusCreateEdit from "../pages/schoolBuses/createEdit.tsx";
import TransferCertificates from "../pages/transferCertificates/index.tsx";
import TransferCertificateCreateEdit from "../pages/transferCertificates/createEdit.tsx";
import Users from "../pages/users/index.tsx";
import UserCreateEdit from "../pages/users/createEdit.tsx";
import UserMenus from "../pages/users/assignMenus.tsx";
import Menus from "../pages/menus/index.tsx";
import MenuCreateEdit from "../pages/menus/createEdit.tsx";

export interface ChildRoute {
  path: string;
  Component: ComponentType;
}

export interface PageRouteConfig {
  Component: ComponentType;
  children?: ChildRoute[];
}

export const pageRoutes: Record<string, PageRouteConfig> = {
  "/dashboard": {
    Component: Dashboard,
  },
  "/management": {
    Component: Management,
    children: [
      { path: "create", Component: ManagementCreateEdit },
      { path: ":id", Component: ManagementCreateEdit },
    ],
  },
  "/departments": {
    Component: Department,
    children: [
      { path: "create", Component: DepartmentCreateEdit },
      { path: ":id", Component: DepartmentCreateEdit },
    ],
  },
  "/fee-structure": {
    Component: FeeStructure,
    children: [
      { path: "create", Component: FeeStructureCreateEdit },
      { path: ":id", Component: FeeStructureCreateEdit },
    ],
  },
  "/results": {
    Component: Results,
    children: [
      { path: "create", Component: ResultCreateEdit },
      { path: ":id", Component: ResultCreateEdit },
    ],
  },
  "/gallery": {
    Component: Gallery,
    children: [
      { path: "create", Component: GalleryCreateEdit },
      { path: ":id", Component: GalleryCreateEdit },
    ],
  },
  "/mandatory-disclosure": {
    Component: MandatoryDisclosure,
    children: [
      { path: "create", Component: MandatoryDisclosureCreateEdit },
      { path: ":id", Component: MandatoryDisclosureCreateEdit },
    ],
  },
  "/staff-details": {
    Component: StaffDetails,
    children: [
      { path: "create", Component: StaffDetailCreateEdit },
      { path: ":id", Component: StaffDetailCreateEdit },
    ],
  },
  "/contact-details": {
    Component: ContactDetails,
    children: [
      { path: "create", Component: ContactDetailCreateEdit },
      { path: ":id", Component: ContactDetailCreateEdit },
    ],
  },
  "/facilities": {
    Component: Facilities,
    children: [
      { path: "create", Component: FacilityCreateEdit },
      { path: ":id", Component: FacilityCreateEdit },
    ],
  },
  "/alumni": {
    Component: Alumni,
    children: [
      { path: "create", Component: AlumniCreateEdit },
      { path: ":id", Component: AlumniCreateEdit },
    ],
  },
  "/contact-configuration": {
    Component: ContactConfiguration,
    children: [
      { path: "create", Component: ContactConfigurationCreateEdit },
      { path: ":id", Component: ContactConfigurationCreateEdit },
    ],
  },
  "/curricular-activities": {
    Component: CurricularActivities,
    children: [
      { path: "create", Component: CurricularActivityCreateEdit },
      { path: ":id", Component: CurricularActivityCreateEdit },
    ],
  },
  "/events": {
    Component: Events,
    children: [
      { path: "create", Component: EventCreateEdit },
      { path: ":id", Component: EventCreateEdit },
    ],
  },
  "/achievements": {
    Component: Achievements,
    children: [
      { path: "create", Component: AchievementCreateEdit },
      { path: ":id", Component: AchievementCreateEdit },
    ],
  },
  "/news": {
    Component: News,
    children: [
      { path: "create", Component: NewsCreateEdit },
      { path: ":id", Component: NewsCreateEdit },
    ],
  },
  "/honours": {
    Component: Honours,
    children: [
      { path: "create", Component: HonourCreateEdit },
      { path: ":id", Component: HonourCreateEdit },
    ],
  },
  "/school-buses": {
    Component: SchoolBuses,
    children: [
      { path: "create", Component: SchoolBusCreateEdit },
      { path: ":id", Component: SchoolBusCreateEdit },
    ],
  },
  "/transfer-certificates": {
    Component: TransferCertificates,
    children: [
      { path: "create", Component: TransferCertificateCreateEdit },
      { path: ":id", Component: TransferCertificateCreateEdit },
    ],
  },
  "/users": {
    Component: Users,
    children: [
      { path: "create", Component: UserCreateEdit },
      { path: ":id/menus", Component: UserMenus },
      { path: ":id", Component: UserCreateEdit },
    ],
  },
  "/menus": {
    Component: Menus,
    children: [
      { path: "create", Component: MenuCreateEdit },
      { path: ":id", Component: MenuCreateEdit },
    ],
  },
};

export function getPageConfig(route: string): PageRouteConfig | undefined {
  return pageRoutes[route];
}